import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';
import { route } from 'preact-router';

@observer
class FeedHighlights extends Component {
    constructor(props) {
        super(props);
        this.state = {
            highlights: [],
        };
    }

    loadAll = async () => {
        const { articleStore } = this.props.stores;
        const { shortsOnly } = this.props;
        const response = await util.fetchApi('/api/articles/feed-highlights', { method: 'GET', publish: false }, {
            hostname: articleStore.currentHostname,
            ...(shortsOnly ? { shortsOnly: 1 } : {}),
        });
        if (response?.status === 200 && Array.isArray(response.data)) {
            this.setState({ highlights: response.data });
        }
    }

    componentDidMount() {
        this.loadAll();
    }

    gotoPost = (e) => {
        const { uuidv4, orientation } = e.currentTarget.dataset;
        // Portrait clips belong in the swipe player; landscape video and image
        // posts keep opening the feed post itself.
        if (orientation === 'portrait') {
            route(`/feed/shorts/${uuidv4}`);
            return;
        }
        route(`/feed/${uuidv4}`);
    }

    gotoFeed = () => {
        const { seeAllRoute = '/feed' } = this.props;
        route(seeAllRoute);
    }

    render() {
        const { highlights } = this.state;
        const {
            classNames = '',
            icon = 'fa-duotone fa-fire',
            title = <Text id='article.feed-highlights'>Popular from the feed</Text>,
        } = this.props;

        if (highlights.length === 0) {
            return (<></>);
        }

        return (<div class={`w-100 ${classNames}`}>
            <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between align-items-baseline mb-1'>
                <span>
                    <i class={`${icon} me-2`} />
                    {title}
                </span>
                <span
                    class='text-primary'
                    style='cursor: pointer; font-size: 0.9rem;'
                    onClick={this.gotoFeed}
                >
                    <Text id='article.feed-highlights-see-all'>See all</Text> <i class='fa-solid fa-arrow-right ms-1' />
                </span>
            </div>
            <div
                class='d-flex flex-row flex-nowrap px-3 pb-2'
                style='overflow-x: auto; scroll-snap-type: x mandatory; gap: 12px; -webkit-overflow-scrolling: touch; max-width: 100%;'
            >
                {highlights.map(post => (
                    <div
                        key={`feed-highlight-${post.uuidv4}`}
                        class='position-relative rounded-lg overflow-hidden flex-shrink-0'
                        style={`width: 150px; height: 210px; scroll-snap-align: start; cursor: pointer; background-image: url("${post.image}"); background-size: cover; background-position: center;`}
                        data-uuidv4={post.uuidv4}
                        data-orientation={post.videoOrientation || ''}
                        onClick={this.gotoPost}
                    >
                        <div
                            class='position-absolute w-100 h-100'
                            style='top: 0; left: 0; background: linear-gradient(180deg, rgba(0,0,0,0.05) 40%, rgba(0,0,0,0.85) 100%);'
                        />
                        {post.isVideo && <span
                            class='position-absolute top-50 start-50 translate-middle d-flex align-items-center justify-content-center rounded-circle'
                            style='width: 44px; height: 44px; background: rgba(0,0,0,0.45); border: 1.5px solid rgba(255,255,255,0.85);'
                        >
                            {/* 2px nudge optically centers the triangle inside the circle */}
                            <i class='fa-solid fa-play text-white' style='font-size: 0.9rem; margin-left: 2px;' />
                        </span>}
                        {post.likeCount > 0 && <span
                            class='position-absolute badge rounded-pill'
                            style='top: 8px; right: 8px; background: rgba(0,0,0,0.55); color: #ff6b81;'
                        >
                            <i class='fa-solid fa-heart' /> {post.likeCount}
                        </span>}
                        <div class='position-absolute w-100 px-2' style='bottom: 8px; left: 0;'>
                            <div
                                class='text-white fw-bold'
                                style='font-size: 0.8rem; line-height: 1.2; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;'
                            >
                                {post.title}
                            </div>
                            <div class='text-white-50' style='font-size: 0.7rem;'>
                                {post.creator} · {util.formatDistance(post.publishDate, new Date(), { textAgo: '' })}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>);
    }
}

export default FeedHighlights;
